export const FETCH_CONTACTS_BEGIN = "FETCH_CONTACTS_BEGIN";
export const FETCH_CONTACTS_SUCCESS = "FETCH_CONTACTS_SUCCESS";
export const FETCH_CONTACTS_FAILURE = "FETCH_CONTACTS_FAILURE";
export const OPEN_CREATE_CONTACT_MODAL = "OPEN_CREATE_CONTACT_MODAL";
export const CLOSE_CREATE_CONTACT_MODAL = "CLOSE_CREATE_CONTACT_MODAL";
